import { createSlice } from '@reduxjs/toolkit';
import {
  EarningHistoryModel,
  EarningInfoModel,
  EarningModel
} from '../views/Earnings/Earnings.types';
import {
  getEarningDetails,
  getEarningHistory,
  initEarnings
} from '../views/Earnings/Earnings.actions';

export interface accountingSliceType {
  loading: boolean;
  loadingHistory: boolean;
  history: EarningHistoryModel[];
  info: EarningInfoModel | null;
  earningDetails: EarningModel | null;
}

const initialState = {
  loading: false,
  loadingHistory: false,
  history: [],
  info: null,
  earningDetails: null
} as accountingSliceType;

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    changeAvailableBalance(state, { payload }) {
      if (state.info) {
        state.info.totalEarnings.availableBalance =
          state.info.totalEarnings.availableBalance - payload;
      }
    },
    removeEarningsState(state) {
      state = initialState;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(initEarnings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(initEarnings.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.info = payload.info;
      state.history = payload.history || [];
    });
    builder.addCase(initEarnings.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getEarningHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEarningHistory.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.history = payload || [];
    });
    builder.addCase(getEarningHistory.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getEarningDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEarningDetails.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.earningDetails = payload || null;
    });
    builder.addCase(getEarningDetails.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { changeAvailableBalance, removeEarningsState } =
  ordersSlice.actions;

export default ordersSlice.reducer;
